import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _excluded = ["children"];
import React from "react";
import { Box } from "atomic-layout";
import { colors } from "../shared/styles";
export var Nav = _styled.nav.withConfig({
  displayName: "Nav",
  componentId: "sc-9vh0re-0"
})(["display:flex;background:#FFF;"]);
export var NavItem = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledBox, Object.assign({
    activeClassName: "navitem-active",
    ref: ref
  }, props, {
    $_css: colors.primaryBlue,
    $_css2: colors.secondaryRed
  }), /*#__PURE__*/React.createElement("span", null, children));
});
var _StyledBox = _styled(Box).withConfig({
  displayName: "Nav___StyledBox",
  componentId: "sc-9vh0re-1"
})(["display:flex;align-items:center;padding:3px 16px;color:", ";font-weight:400;text-decoration:none;&.navitem-active{padding-bottom:0px;border-bottom:3px solid ", ";}&:hover{opacity:0.7;}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});